/* Trappbutiken – delad länkmodul för konfiguratorerna (Wubs, 2026-09-24).
 *
 * EN konfiguration = en URL. `?k=<kodad>` bär kundens VAL, och konfiguratorn återskapar
 * sig själv ur den. Det gör tre saker möjliga som inte gick förut:
 *   · spara/dela en konfiguration (önskelistan lägger länken på sin rad)
 *   · "Ändra" i varukorgen (raden bär länken i den dolda egenskapen _konfig_url)
 *   · "Ändra" i önskelistan
 *
 * ⚠️⚠️ LÄNKEN BÄR ALDRIG PRISER. Bara val: träslag, ytbehandling, mått, kant-/hörnval,
 * NCS-kod, variant-id på beslag/tillbehör. Priserna räknas om av konfiguratorn när länken
 * öppnas – annars hade en länk från igår visat gårdagens pris i kassan, och pristrappan
 * (som Tom justerar i prisappen) hade kunnat gå isär med det som faktiskt debiteras.
 *
 * ⚠️ Etiketter, inte index. "Furu 21 mm" överlever att Tom sorterar om varianterna i admin;
 * ett index gör det inte. Byter en variant NAMN dör länken – då faller konfiguratorn tillbaka
 * på tomt läge i stället för att välja fel (se plocka() i varje konfigurator).
 *
 * ERSÄTTNINGSFLÖDET (Ändra): länken bär också `?ers=<konfig_id>`. Alla rader en konfigurator
 * lägger i korgen stämplas med samma `_konfig_id`. Lägger kunden i korgen med `ers` satt
 * tas de gamla raderna bort EFTER att de nya lagts till – aldrig före, så ett fel på vägen
 * inte kan lämna kunden med en tom korg och en förlorad konfiguration.
 */
(function () {
  'use strict';

  var PARAM = 'k';
  var ERS = 'ers';
  /* `?start=1` – öppna länken på STEG 1 i stället för på sista steget.
     Varför en markering i länken och inte ett val i varje konfigurator: de tre flödena som
     öppnar en `?k=`-länk vill olika saker, och bara länken vet vilket flöde det är.
       · "Ändra" från korgen/önskelistan → sista steget (kunden är klar och vill se helheten)
       · "Fortsätt" på ett autosparat UTKAST → steg 1 (Liam 2026-10-02: "Klickar man fortsätt,
         så hamnar man på sista steget. hamna på första är bättre") – en påbörjad konfiguration
         är inte färdig, och att kastas in i sista steget gömmer det som återstår att välja. */
  var START = 'start';

  /* `?tra=Ek` – FÖRVALT TRÄSLAG (2026-10-04, Liam: "kan det träslaget man klickat vara förvalt
     i första steget och att 3d-modellen har det träslaget, så man kommer mer rätt").
     Kunden som klickat sig fram till ett träslag – ett materialkort i en kategori, ett
     träslagsfilter, en produktsida – ska mötas av just det träslaget i steg 1.

     ⚠️ EN EGEN, LÄSBAR PARAMETER – inte ett `?k=`-nyttolast med bara `w`. Två skäl:
       · `?k=` betyder "en färdig konfiguration": varje konfigurator hoppar till SISTA steget
         så fort den finns (korgens "Ändra" vill just det, se START ovan). Ett förval är det
         motsatta – en början, som ska landa på steg 1.
       · länken skrivs i Liquid (kollektionens konfiguratorkort, produktsidans knapp). `?tra=Ek`
         går att skriva var som helst och syns i adressfältet; en base64-kodad JSON gör inte det.
     ⚠️ Ett förval är INTE ett val kunden gjort i konfiguratorn: det fyller aldrig det autosparade
     utkastet (`wubs-konfig-utkast.js` frågar bara efter `?k=`) och bär aldrig `ers`.
     ⚠️ Bär bara TRÄSLAGET, aldrig ytbehandlingen. Materialkortet i kategorin väljer sin bild ur
     den FÖRSTA tillgängliga varianten i materialet – kulören där är kortets, inte kundens. */
  var TRA = 'tra';

  /* `?yt=Dala-Floda` – FÖRVALD YTBEHANDLING, samma tanke som `tra` (2026-10-04, Liam: "så att
     den man var inne på / vald är förvald i konfiguratorn"). Följer bara med från ytor där
     kulören ÄR kundens val: produktsidans knapp (kortet i kategorin heter "Ledstång i Ask
     Dala-Floda" – träslag OCH kulör) och ett ensamt aktivt ytbehandlingsfilter.
     ⚠️ Kräver `tra`: en ytbehandling utan träslag går inte att slå upp – listan med
     ytbehandlingar är olika för varje träslag. */
  var YT = 'yt';

  /* base64url. Måste gå via TextEncoder: btoa kvävs på å, ä, ö och ×, som finns i
     både träslagsnamn ("Målad bruten vit") och måttetiketter. */
  function koda(obj) {
    try {
      var json = JSON.stringify(obj);
      var bytes = new TextEncoder().encode(json);
      var bin = '';
      for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
      return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) {
      return '';
    }
  }

  function avkoda(str) {
    if (!str) return null;
    try {
      var b = String(str).replace(/-/g, '+').replace(/_/g, '/');
      while (b.length % 4) b += '=';
      var bin = atob(b);
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      var obj = JSON.parse(new TextDecoder().decode(bytes));
      return (obj && typeof obj === 'object') ? obj : null;
    } catch (e) {
      /* Trasig eller avhuggen länk (mejlklienter bryter långa rader) – tyst tomt läge.
         Ett fel här får ALDRIG stoppa konfiguratorn från att starta. */
      return null;
    }
  }

  /* Vad som står i adressfältet just nu. `typ` filtrerar: tröskelns länk ska inte
     kunna öppnas av hyllplanskonfiguratorn om båda råkar ligga på samma sida. */
  function las(typ) {
    var ut = { data: null, ers: '', start: false, tra: '', yt: '' };
    try {
      var q = new URLSearchParams(window.location.search);
      ut.ers = String(q.get(ERS) || '').trim();
      ut.start = q.get(START) === '1';
      ut.tra = String(q.get(TRA) || '').trim();
      ut.yt = String(q.get(YT) || '').trim();
      var d = avkoda(q.get(PARAM));
      if (d && (!typ || d.t === typ)) ut.data = d;
    } catch (e) {}
    return ut;
  }

  /* Absolut URL till en konfiguratorsida. `sokvag` tom = den sida vi står på.
     `start` sant = mottagaren ska landa på steg 1 (se START ovan). */
  function url(obj, ers, sokvag, start) {
    var bas = sokvag || (window.location.origin + window.location.pathname);
    if (bas.indexOf('http') !== 0) bas = window.location.origin + (bas.charAt(0) === '/' ? '' : '/') + bas;
    var kod = koda(obj);
    if (!kod) return bas;
    var u = bas + '?' + PARAM + '=' + kod;
    if (ers) u += '&' + ERS + '=' + encodeURIComponent(ers);
    if (start) u += '&' + START + '=1';
    return u;
  }

  /* ---- Förvalt träslag: kundens ord → konfiguratorns etikett --------------------- */

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* Orden i en etikett. Skiljetecken skiljer ord – men BINDESTRECK gör det inte: "Dala-Floda"
     är ett namn, inte två ord. */
  function ord(s) {
    return norm(s).split(/[\s()\[\]{},;:/|+·]+/).filter(Boolean);
  }

  /* Finns kundens ord som en hel ordföljd i etiketten? ORDMATCHNING, inte substräng: "ek" ska
     hitta "Ek 8 mm" och "Grangärde (Ek; Vit)" men ALDRIG "Gammeldags ektröskel 16 mm" – ett
     annat material i en annan tjocklek. (Samma fälla som produktkortets träslagsmatchning,
     se docs/kollektion.md.) */
  function harOrd(etikett, sokt) {
    var a = ord(etikett), b = ord(sokt);
    if (!b.length || b.length > a.length) return false;
    for (var i = 0; i <= a.length - b.length; i++) {
      var alla = true;
      for (var j = 0; j < b.length; j++) {
        if (a[i + j] !== b[j]) { alla = false; break; }
      }
      if (alla) return true;
    }
    return false;
  }

  /* Kundens val uttryckt i KONFIGURATORNS EGNA etiketter (träslag ur `tra`, ytbehandling ur `yt`) – eller '' när det inte går att
     avgöra. `lista` är materialaxeln så som konfiguratorn ser den ("Ek", "Ask" … på ledstången,
     "Ek 8 mm", "Furu 12 mm" … på tröskeln).

     ⚠️ ETIKETTER, INTE INDEX – som hela resten av modulen. Byter Tom namn på ett träslag faller
     förvalet bort i stället för att peka på ett annat material.
     ⚠️⚠️ ENTYDIGT ELLER INGENTING. "Furu" matchar BÅDE "Furu 8 mm" och "Furu 12 mm" på tröskeln
     – två tjocklekar till olika pris. Att ta den första hade varit att svara på en fråga kunden
     inte fått; ett öppet steg 1 är då det ärliga. Exakt träff på hela etiketten vinner alltid,
     så ett klick på materialkortet "Furu 12 mm" ger förval ändå.
     ⚠️ Träslag som konfiguratorn DÖLJER (björk och läderlindad på ledstången, 2026-09-21) finns
     inte i `lista` och kan därför inte förväljas. Det är avsikten – kortet i kategorin finns,
     men konfiguratorn säljer dem inte. */
  function valjTra(lista, ra) {
    var sokt = norm(ra);
    if (!sokt || !lista || !lista.length) return '';
    var i;
    for (i = 0; i < lista.length; i++) {
      if (norm(lista[i]) === sokt) return lista[i];
    }
    var traff = '', antal = 0;
    for (i = 0; i < lista.length; i++) {
      if (harOrd(lista[i], sokt)) { traff = lista[i]; antal++; }
    }
    return antal === 1 ? traff : '';
  }

  /* Id som binder ihop alla rader från EN konfiguration. Måste vara nytt vid varje
     köp: identiska rader med samma id hade slagits ihop av Shopify, och då tagit bort
     sig själva när de gamla raderna städas. */
  function nyId() {
    return 'kf' + Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36);
  }

  /* Vilka rader ska ut ur attributet `Konfiguration` när gruppen ersätts? Läget på sidan duger bara första
     gången: öppnas samma grupp via utkastet är läget redan ändrat, och ordern hade fått en rad för något som
     aldrig köptes ("90×12||100×12", 2026-11-03). Därför sparas det som stod första gången, per grupp. */
  var GAMLA = 'wubs:konfig-gamla:';
  function gamlaRader(ers, rader) {
    if (!ers) return [];
    try {
      var sparad = JSON.parse(localStorage.getItem(GAMLA + ers) || 'null');
      if (Array.isArray(sparad)) return sparad;
      localStorage.setItem(GAMLA + ers, JSON.stringify(rader));
    } catch (e) { /* privat läge: som förut */ }
    return rader;
  }
  function glomGamlaRader(ers) {
    try { localStorage.removeItem(GAMLA + ers); } catch (e) { /* privat läge */ }
  }

  /* Tar bort korgrader med ett visst _konfig_id. Nycklar (item.key), inte variant-id:
     samma variant kan ligga på flera rader med olika mått, och ett variant-id hade
     träffat dem alla. */
  function taBortRader(konfigId) {
    if (!konfigId) return Promise.resolve(null);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var antal = 0;
        (cart && cart.items ? cart.items : []).forEach(function (it) {
          var p = it && it.properties;
          if (p && String(p._konfig_id || '') === String(konfigId)) {
            updates[it.key] = 0;
            antal++;
          }
        });
        if (!antal) return cart;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .catch(function () { return null; });
  }

  window.WubsKonfigLank = {
    PARAM: PARAM,
    ERS: ERS,
    START: START,
    TRA: TRA,
    YT: YT,
    koda: koda,
    avkoda: avkoda,
    las: las,
    valjTra: valjTra,
    /* Samma funktion, tydligare namn när den slår upp en ytbehandling. */
    valjEtikett: valjTra,
    url: url,
    nyId: nyId,
    gamlaRader: gamlaRader,
    glomGamlaRader: glomGamlaRader,
    taBortRader: taBortRader
  };
})();
